import React, { HTMLAttributes, useMemo } from 'react';
import cc from 'classcat';
import styles from './PaginationSummary.module.scss';
import { useTranslation } from 'react-i18next';

const keyPrefix = 'components.appTable.pagination.paginationSummary';

interface IWMPaginationSummaryProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
    pageSize: number;
    currentPage: number;
    totalSize: number;
}

export default function PaginationSummary({
    className,
    pageSize,
    currentPage,
    totalSize,
    ...otherProps
}: IWMPaginationSummaryProps): JSX.Element {
    const { t } = useTranslation('', { keyPrefix });

    const from = useMemo(() => pageSize * currentPage + 1, [pageSize, currentPage]);
    const to = useMemo(() => Math.min(pageSize * currentPage + pageSize, totalSize), [pageSize, currentPage, totalSize]);

    return (
        <div className={cc([styles.wmPaginationSummary, className])} {...otherProps}>
            {t('showing', { from, to, total: totalSize })}
        </div>
    );
}
